import { createAction } from '@reduxjs/toolkit';
export const ON_DISCONNECT = 'ON_DISCONNECT';
export const onDisconnectAction = createAction(ON_DISCONNECT);